import { RollbarService, setUser } from '@/app/core/services/rollbar.service';
import { ROLLBAR_ENV } from '@/app/core/common/config';

export const initializeRollbar = async (store) => {
    if (!RollbarService) {
        return;
    }

    RollbarService.configure({
        payload: {
            logLevel: 'info',
            environment: ROLLBAR_ENV,
        },
    });

    const user = store.getters['User/user'];

    if (user) {
        setUser(user);
    }
};
